import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDeviceFromList } from "../../actions/deviceActions";
import { planActions, workOrderActions } from "../../actions/StoreActions";
import AssignedWO from "../../components/Panel/AssignedWO";
import TaskList from "../../components/Panel/TaskLists";

export default function Panel() {
  const { assignedOrders } = useSelector((state) => state.workOrder);
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.people);
  const { plan } = useSelector((state) => state.plan);
  const [conditions, setConditions] = useState(null);
  const [pendant, setPendant] = useState([]);
  const [current, setCurrent] = useState([]);
  const [next, setNext] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  // const isAdmin = userData?.access === "admin";

  useEffect(() => {
    dispatch(workOrderActions.getAssignedOrders());
  }, [dispatch]);

  useEffect(() => {
    if (isFetching && plan) {
      setIsFetching(false);
    }
  }, [isFetching, plan]);

  useEffect(() => {
    if (userData?.user) {
      const hasPlant = !!userData.plant;
      const year = new Date().getFullYear();
      const filters = { year };
      const isAdmin = userData.access.toLowerCase() === "admin";
      if (hasPlant) filters.plant = userData.plant;
      if (!isAdmin) filters.user = userData.user;
      setConditions(filters);
    }
  }, [userData]);

  useEffect(() => {
    setIsFetching(true);
    dispatch(planActions.selectTask(undefined));
    dispatch(getDeviceFromList({}));
  }, [dispatch]);

  useEffect(() => {
    conditions && dispatch(planActions.getPlan(conditions));
  }, [conditions, dispatch]);

  useEffect(() => {
    if (!plan || plan.length === 0) return;

    // 1. Configuración limpia de fechas base (sin mutaciones)
    const today = new Date();
    const weekDay = today.getDay(); // 0 (Domingo) a 6 (Sábado)
    const daysFromLastMonday = weekDay === 0 ? 6 : weekDay - 1;

    // LUNES SEMANA ACTUAL (W0)
    const lastMonday = new Date(today);
    lastMonday.setDate(today.getDate() - daysFromLastMonday);
    lastMonday.setHours(0, 0, 0, 0);

    // LUNES SEMANA SIGUIENTE (W+1)
    const nextMonday = new Date(lastMonday);
    nextMonday.setDate(lastMonday.getDate() + 7);

    // LUNES SEMANA PRÓXIMA (W+2)
    const endNextWeek = new Date(lastMonday);
    endNextWeek.setDate(lastMonday.getDate() + 14);

    // 2. Clasificación por rangos estrictos basados en tus definiciones del backend

    // PENDANTS: Todo lo anterior a esta semana, ordenado por avance desc, luego código asc
    const pendingTasks = plan
      .filter((element) => {
        const taskDate = new Date(element.date);
        return taskDate < lastMonday && element.completed < 100;
      })
      .sort((a, b) => {
        // 1º Criterio: Mayor avance primero (Descendente)
        if (b.completed !== a.completed) {
          return (b.completed || 0) - (a.completed || 0);
        }
        // 2º Criterio (Desempate): Por código (Ascendente)
        return (a.code || 0) - (b.code || 0);
      });

    // CURRENTS: Todo lo de esta semana, ordenado por avance desc, luego código asc
    const currentTasks = plan
      .filter((element) => {
        const taskDate = new Date(element.date);
        return taskDate >= lastMonday && taskDate < nextMonday;
      })
      .sort((a, b) => {
        // 1º Criterio: Mayor avance primero (Descendente)
        if (b.completed !== a.completed) {
          return (b.completed || 0) - (a.completed || 0);
        }
        // 2º Criterio (Desempate): Por código (Ascendente)
        return (a.code || 0) - (b.code || 0);
      });

    // NEXT: Todo lo de la semana que viene (Normalmente se deja por fecha o código)
    const nextTasks = plan
      .filter((element) => {
        const taskDate = new Date(element.date);
        return taskDate >= nextMonday && taskDate < endNextWeek;
      })
      .sort((a, b) => (a.code || 0) - (b.code || 0)); // Ordenado solo por código para consistencia

    // 3. Actualizamos los estados del componente
    setPendant(pendingTasks);
    setCurrent(currentTasks);
    setNext(nextTasks);
  }, [plan]);
  // useEffect(() => {
  //   //current week monday
  //   const today = new Date();
  //   const lastMonday =
  //     today.getDay() === 1
  //       ? today
  //       : new Date(today.setDate(today.getDate() - (today.getDay() - 1)));
  //   let nextMonday = new Date(lastMonday);
  //   nextMonday.setDate(lastMonday.getDate() + 7);
  //   const codes = [...new Set(plan.map((element) => element.code))];

  //   //set pendants, currents and netx tasks
  //   const pendantCodes = codes.filter((code) => {
  //     // select code tasks
  //     const codeTasks = plan.filter((date) => date.code === code);
  //     const mostRecentDone = codeTasks
  //       .filter((d) => d.completed === 100)
  //       .sort((d1, d2) => new Date(d1.date) - new Date(d2.date))
  //       .reverse()[0];

  //     if (!mostRecentDone) {
  //       return true;
  //     }
  //     const hasReallyPendant = codeTasks.find(
  //       (date) =>
  //         new Date(date.date) < new Date() &&
  //         new Date(date.date) > new Date(mostRecentDone.date) &&
  //         date.completed < 100
  //     );
  //     return !!hasReallyPendant;
  //   });

  //   setPendant(
  //     plan.filter(
  //       (element) =>
  //         pendantCodes.includes(element.code) &&
  //         new Date(element.date) < new Date() &&
  //         element.completed < 100
  //     )
  //   );

  //   setCurrent(
  //     plan.filter(
  //       (element) =>
  //         new Date(element.date).toLocaleDateString() ===
  //         lastMonday.toLocaleDateString()
  //     )
  //   );
  //   setNext(
  //     plan.filter(
  //       (element) =>
  //         new Date(element.date).toLocaleDateString() ===
  //         nextMonday.toLocaleDateString()
  //     )
  //   );
  // }, [plan]);

  useEffect(
    () => console.log(plan.map(({ date, completed }) => ({ date, completed }))),
    [plan]
  );

  return (
    <div className="page-container">
      {assignedOrders.length > 0 ? (
        <AssignedWO />
      ) : (
        <>
          {!isFetching && !plan[0] ? (
            <>
              <div className="page-title text-error">
                No hay un plan cargado para este año en su planta
              </div>
            </>
          ) : (
            <TaskList
              loading={!!isFetching}
              pendant={pendant}
              current={current}
              next={next}
              access={userData.access}
            />
          )}
        </>
      )}
    </div>
  );
}
